import {
    GET_MAQUINA_DETALLES, ADD_NEW_MAQUINA,
    ADD_CENTRO_MAQUINA, DELETE_CENTRO_MAQUINA, MODIFY_CENTRO_MAQUINA
} from '../constants/action_types';

const initialState = { maquinaCentros: [], isLoading: false };

export default function (state = initialState, action) {

    switch (action.type) {
        case GET_MAQUINA_DETALLES:

            return {
                maquinaCentros: [],
                isLoading: true
            };

        case GET_MAQUINA_DETALLES + "_SUCCESS":

            return {
                maquinaCentros: action.payload.data.centros,
                isLoading: false
            };

        case ADD_CENTRO_MAQUINA:

            const newArr = [...state.maquinaCentros, action.payload]

            return {
                maquinaCentros: newArr,
                isLoading: false
            };

        case MODIFY_CENTRO_MAQUINA:
            return {
                maquinaCentros: state.maquinaCentros.map((centro) => {
                    if (centro.id !== action.payload.id) return centro;
                    else return action.payload;
                }),
                isLoading: false
            };

        case DELETE_CENTRO_MAQUINA:
            return {
                maquinaCentros: state.maquinaCentros.filter(centro => centro.id !== action.payload.id),
                isLoading: false
            };

        case ADD_NEW_MAQUINA:
            
            return initialState;

        default:

            return state;
    }

}